import { styled } from '@mui/system';
import { DataGrid as DataGridMUI } from '@mui/x-data-grid/DataGrid/DataGrid';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;

export const Title = styled('div')`
  font-weight: 700;
  font-size: 16px;
  color: ${theme.palette.text.dark};
`;

export const DataGrid = styled(DataGridMUI)`
  margin-top: 10px;
  border-top: none;
  border-left: none;
  border-right: none;
  line-height: normal;
  margin-bottom: 8px;

  .MuiDataGrid-columnHeader {
    font-weight: 700;
    font-size: 12px;
  }

  .MuiDataGrid-cell {
    padding: 4px 12px;
    font-size: 13px;
  }
`;

export const NumberField = styled('div')`
  font-weight: 700;
  color: ${theme.palette.secondary.main};

  &.active {
    cursor: pointer;
    color: ${theme.palette.primary.main};
  }
`;

export const Status = styled('div')`
  display: inline-flex;
  align-items: center;
`;

export const StatusIcon = styled('div')`
  width: 26px;
  height: 26px;
  border: 1px solid ${theme.palette.secondary.main};
  color: ${theme.palette.secondary.main};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 16px;

  &.success {
    color: ${theme.palette.success.main};
    border-color: ${theme.palette.success.main};
  }

  &.warning {
    color: ${theme.palette.warning.main};
    border-color: ${theme.palette.warning.main};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
